import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Store, select} from '@ngrx/store';
import {Observable, take, tap} from 'rxjs';
import {BreakpointUtilityService} from '../../common/service';
import {CartItem, OnDestroySubject} from '../../data/model';
import {Router} from '@angular/router';
import {
  selectCartLoadingState,
  selectCheckEmptyCart,
  selectFailedAddons,
} from '../../common/shopping-cart/cart.selectors';
import {
  clearFailedItems,
  completeOrder,
  retryAddCartItems,
} from '../../common/shopping-cart/cart.actions';

@Component({
  selector: 'app-failed-add-ons',
  templateUrl: './failed-add-ons.component.html',
  styleUrls: ['./failed-add-ons.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FailedAddOnsComponent extends OnDestroySubject {
  failedAddons: Array<CartItem>;
  failedAddons$: Observable<Array<CartItem>>;
  loading$: Observable<boolean>;

  constructor(
    protected breakpointUtils: BreakpointUtilityService,
    private store: Store,
    private router: Router,
  ) {
    super();
    this.failedAddons$ = this.store.pipe(
      select(selectFailedAddons),
      tap(
        (failedAddons: Array<CartItem>) => (this.failedAddons = failedAddons),
      ),
    );

    this.loading$ = this.store.pipe(select(selectCartLoadingState));
  }

  retry(): void {
    this.store.dispatch(retryAddCartItems({cartItems: this.failedAddons}));
  }

  continue(): void {
    this.store.dispatch(clearFailedItems());
    this.store
      .pipe(select(selectCheckEmptyCart), take(1))
      .subscribe(emptyCart => {
        if (emptyCart) {
          this.store.dispatch(completeOrder());
          return;
        }
        this.router.navigate([
          {outlets: {commerceElement: 'commerce/address'}},
        ]);
      });
  }
}
